<div class="tile-padding-first tile-padding">
  <h3>{{sessionTileParams.sessionHeader}}</h3>

  <div>
    <app-data-table
      [columns]="columns"
      [data]="rows"
      [pageSize]="5"
      [emptyMessage]="sessionTileParams.sessionNodata"
      (rowClick)="onDataClicked($event)">

      <ng-template appColumnCell="student" let-element>
        <div class="student-group-icon-container tw:mr-2 tw:float-left"
              [ngClass]="{'single-student-icon': !element.isGroupPlacement,
                            'group-one-student-icon': element.isGroupPlacement && element.groupSize == 1,
                            'group-two-student-icon': element.isGroupPlacement && element.groupSize == 2,
                            'group-three-student-icon': element.isGroupPlacement && element.groupSize == 3,
                            'group-multiple-student-icon': element.isGroupPlacement && element.groupSize > 3}"></div>{{element.isGroupPlacement == true ? element.groupName : element.student}}
      </ng-template>

      <ng-template appColumnCell="time" let-element>
        {{element.startDate | date : 'HH:mm'}} - {{element.endDate | date : 'HH:mm'}}
      </ng-template>

      <ng-template appColumnCell="status" let-element>
        <app-session-status-pill [status]="element.status"></app-session-status-pill>
      </ng-template>
    </app-data-table>
  </div>
</div>
